import React from 'react';
import { ArrowUpRight, Folder } from 'lucide-react';
import { projects } from '../data/mock';

const Projects = () => {
  return (
    <section id="projects" className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <span className="label-text text-[rgba(35,35,35,0.5)] mb-4 block">Selected Work</span>
          <h2 className="section-title">Projects</h2>
        </div>

        {/* Projects Grid */}
        <div className="space-y-8">
          {projects.map((project, idx) => (
            <a
              key={project.id}
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block"
            >
              <div className="card-sharp group cursor-pointer overflow-hidden">
                <div className="p-8 lg:p-10">
                <div className="flex flex-col lg:flex-row lg:items-start gap-6 lg:gap-12">
                  {/* Project Number */}
                  <div className="flex-shrink-0">
                    <span className="font-mono text-6xl lg:text-8xl font-bold text-[rgba(35,35,35,0.1)] group-hover:text-[#38FF62] transition-colors duration-300">
                      {String(idx + 1).padStart(2, '0')}
                    </span>
                  </div>

                  {/* Project Content */}
                  <div className="flex-1">
                    {/* Category Badge */}
                    <span className="inline-block px-3 py-1 bg-[#38FF62] font-mono text-[10px] uppercase tracking-wider mb-4">
                      {project.category}
                    </span>

                    {/* Title */}
                    <h3 className="font-display text-2xl lg:text-3xl font-semibold mb-2 group-hover:text-[#38FF62] transition-colors">
                      {project.title}
                    </h3>
                    <p className="font-body text-lg text-[rgba(35,35,35,0.6)] mb-4">
                      {project.subtitle}
                    </p>

                    {/* Description */}
                    <p className="font-body text-[rgba(35,35,35,0.8)] mb-6 max-w-2xl">
                      {project.description}
                    </p>

                    {/* Highlights */}
                    <div className="space-y-2 mb-6">
                      {project.highlights.map((highlight, hIdx) => (
                        <div key={hIdx} className="flex items-start gap-3">
                          <span className="w-1.5 h-1.5 bg-[#38FF62] mt-2 flex-shrink-0"></span>
                          <span className="font-body text-sm text-[rgba(35,35,35,0.7)]">
                            {highlight}
                          </span>
                        </div>
                      ))}
                    </div>

                    {/* Technologies */}
                    <div className="flex flex-wrap gap-2">
                      {project.technologies.map((tech, tIdx) => (
                        <span
                          key={tIdx}
                          className="px-3 py-1.5 border border-[rgba(35,35,35,0.2)] font-mono text-xs uppercase tracking-wider"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Arrow Icon */}
                  <div className="flex-shrink-0 hidden lg:block">
                    <div className="p-4 border border-[rgba(35,35,35,0.2)] group-hover:bg-[#38FF62] group-hover:border-[#38FF62] transition-all duration-300">
                      <ArrowUpRight className="w-6 h-6 group-hover:text-[#232323]" />
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;